import {
	CANCELLED,
	RUNNING,
	ENDED,
	UPCOMING_STATES,
	BEFORE_RUNNING_STATES,
	PENDING_START,
	ARCHIVED
} from '../constants/we-spin-stream-states.js';

import {
	ROUTE_WE_SPIN_GAME_ROOM_CHAT,
	ROUTE_WE_SPIN_GAME_ROOM_BUY_IN,
	ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
	ROUTE_WE_SPIN_GAME_ROOM_PREVIEW,
	ROUTE_WE_SPIN_GAME_ROOM_EVENT_NOT_FOUND
} from '../constants/we-spin-route-constants.js';

const STREAM_VIEW_GAME_ROOM_PATH_JOINED = BEFORE_RUNNING_STATES.filter(state => state !== RUNNING).reduce(
	(acc, state) => {
		acc[state] = ROUTE_WE_SPIN_GAME_ROOM_PREVIEW;
		return acc;
	},
	{
		[PENDING_START]: ROUTE_WE_SPIN_GAME_ROOM_PREVIEW,
		[CANCELLED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
		[ENDED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
		[RUNNING]: ROUTE_WE_SPIN_GAME_ROOM_CHAT
	}
);

const STREAM_VIEW_GAME_ROOM_PRIVATE_PATH_JOINED = BEFORE_RUNNING_STATES.filter(state => state !== RUNNING).reduce(
	(acc, state) => {
		acc[state] = ROUTE_WE_SPIN_GAME_ROOM_PREVIEW;
		return acc;
	},
	{
		[PENDING_START]: ROUTE_WE_SPIN_GAME_ROOM_PREVIEW,
		[CANCELLED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
		[ENDED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
		[RUNNING]: ROUTE_WE_SPIN_GAME_ROOM_PREVIEW
	}
);

const STREAM_VIEW_GAME_ROOM_PATH_NOT_JOINED = UPCOMING_STATES.filter(state => state !== RUNNING).reduce(
	(acc, state) => {
		acc[state] = ROUTE_WE_SPIN_GAME_ROOM_BUY_IN;
		return acc;
	},
	{
		[ARCHIVED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_NOT_FOUND,
		[CANCELLED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
		[ENDED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
		[RUNNING]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST
	}
);

const STREAM_VIEW_GAME_ROOM_PRIVATE_PATH_NOT_JOINED = UPCOMING_STATES.filter(state => state !== RUNNING).reduce(
	(acc, state) => {
		acc[state] = ROUTE_WE_SPIN_GAME_ROOM_BUY_IN;
		return acc;
	},
	{
		[ARCHIVED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_NOT_FOUND,
		[CANCELLED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
		[ENDED]: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
		[RUNNING]: ROUTE_WE_SPIN_GAME_ROOM_PREVIEW
	}
);

export const streamToGameRoomRoute = streamView => {
	let streamUrl = '';
	if (streamView.joined) {
		if (streamView.isPrivateStreamer) {
			streamUrl = STREAM_VIEW_GAME_ROOM_PRIVATE_PATH_JOINED[streamView.state];
		} else {
			streamUrl = STREAM_VIEW_GAME_ROOM_PATH_JOINED[streamView.state];
		}
	} else if (streamView.isPrivateStreamer) {
		streamUrl = STREAM_VIEW_GAME_ROOM_PRIVATE_PATH_NOT_JOINED[streamView.state];
	} else {
		streamUrl = STREAM_VIEW_GAME_ROOM_PATH_NOT_JOINED[streamView.state];
	}
	return `${streamUrl}/${streamView.streamRef}`;
};

export const streamToGameRoomRouteEventList = streamRef => {
	return `${ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST}/${streamRef}`;
};
